import {
    ONBOARD_COMPANY,
    COMPANY_ONBOARD_SUCCESS,
    COMPANY_ONBOARD_FAILURE
} from "../constants";

const initialState = {
    // detailLoader: false,
    loader: false,
    // invitedClientsData: [],
    // invitedClientDetailData: [],
    // companiesData: [],
    // companiesDetailData: [],
}

export default function CompanyOnboardingReducer(state = initialState, action) {

    switch (action.type) {

        case ONBOARD_COMPANY:
            state = {
                ...state,
                loader: true
            }
            break;

        case COMPANY_ONBOARD_SUCCESS:
            state = {
                ...state,
                loader: false,
            }
            break;

        case COMPANY_ONBOARD_FAILURE:
            state = {
                ...state,
                loader: false
            }
            break;

        
        default:
            state = { ...state }
            break
    }
    return state
}